import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigCarouselComponent } from './uig-carousel.component';
import { RouterModule } from '@angular/router';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { I18nModule, UrlModule } from '@spartacus/core';



@NgModule({
  declarations: [UigCarouselComponent],
  exports: [UigCarouselComponent],
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
    MediaModule,
    UrlModule,
    I18nModule
  ]
})
export class UigCarouselModule { }
